export const secciones = [
  {
    title: "Home",
    id: "1",
    img: "/img/slots/logo.png",
    category: "Section",
  },
  {
    title: "Casino",
    id: "2",
    img: "/img/slots/casinovivo.png",
    category: "Section",
  },
  {
    title: "Slots",
    id: "3",
    img: "/img/slots/slots.png",
    category: "Section",
  },
  {
    title: "Deportes",
    id: "4",
    img: "img/slots/deportes.png",
    category: "Section",
  },
];
